const FaqCategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-faq-category" */ '@/pages/base-info/crm/faq-category/index.vue'
  )
const CreateFaqCategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-faq-category" */ '@/pages/base-info/crm/faq-category/create.vue'
  )
const EditFaqCategory = () =>
  import(
    /* webpackChunkName: "base-info-crm-faq-category" */ '@/pages/base-info/crm/faq-category/edit.vue'
  )

export default {
  path: 'faq-category',
  meta: {
    label: 'faqCategory',
    auth: 'faqCategory'
  },
  component: {
    name: 'FaqCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCmsFaqCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: FaqCategory
    },
    {
      name: 'BaseInfoCreateCmsFaqCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateFaqCategory
    },
    {
      name: 'BaseInfoEditCmsFaqCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditFaqCategory,
      props: true
    }
  ]
}
